import React,{useEffect} from 'react'
import IxModal from '../../composite/ix-modal'
import DialogActions from '@material-ui/core/DialogActions';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';
import useStyles  from '../pickup-time/styles';
import Button from '@material-ui/core/Button';
import { setOrder } from '../../../actions/cart';
import { setBlockModal } from './paymentSlice';
import {getCancelOrderRouteFromSessionStorage,removeCancelOrderRouteFromSessionStorage} from "../../../actions/nxt-local-storage"


const PaymentRouteBlockModal = ({
    openModal,
    loading,
    setOpenModal,history
}) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const dispatch = useDispatch()



  const handleCancel =()=>{
    dispatch(setBlockModal(false))
    setOpenModal(false)
    
  }
  const handleOk =()=>{
      handleCancel();
      dispatch(setOrder(null))
      history.push(getCancelOrderRouteFromSessionStorage())
  }
  useEffect(()=>{
   return()=>{
    removeCancelOrderRouteFromSessionStorage()
   }
  },[history])
return (
        <IxModal 
        open={openModal}
        maxWidth="450px"
        modaltitle={t('Your order will be discarded. Are you sure?')}
       >
           <DialogActions>
                <Box width="40%">
                {/* <Field name="isActive" component={IxSwitch} label={t('common.active')}></Field> */}
                </Box>
                <Button variant="contained" onClick={handleCancel}>
                {t('Cancel')}
                </Button>
                <Button type="submit"  variant="contained" onClick={handleOk}  style={{backgroundColor:"#ffe100"}}>
                {t('Ok')}
                </Button>
                {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
            </DialogActions>
        </IxModal>
    
    )
}

export default PaymentRouteBlockModal
